import ReactRailsUJS from 'react_ujs';
import "core-js/stable";
import "regenerator-runtime/runtime";
import '@brandfolder/react/lib/esm/index.css';

ReactRailsUJS.useContext(require.context('components', true));
